export const ROLE_OPTIONS = [
	{ label: "SuperAdmin", value: "SuperAdmin" },
	{ label: "Admin", value: "Admin" },
	{ label: "User", value: "User" },
	{ label: "Guest", value: "Guest" },
];
